<template>
    <div class="footer">
    <div class="footer-main">
      <div class="logo-box">
        <img class="footer-logo" src="~@/assets/images/footer-logo.png" />
        <!-- <img class="footer-logo" src="~@/assets/images/logo2.png" /> -->
      </div>
      <div class="footer-text">
        <!-- <p>a GameSamba company</p> -->
        <p>©FunCat Games Limited, Inc. All Rights Reserved.</p>
        <p>
          <router-link class="policy" target="_blank" v-if="data.privacy" :to="data.url">{{
            data.privacy
          }}</router-link>
          | <router-link to="/aboutUs" class="about">{{ data.about }}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {}
    };
  },
  props: {
    resData: {}
  },
  watch: {
    resData (newData) {
      this.data = newData;
    }
  },
  methods: {
    imgfun (title) {
      return require("@/assets/images/" + this.$parent.pagelist[title]);
    }
  },
  mounted () {}
};
</script>

<style scoped>
.footer {
  width: 100%;
  margin: auto;
  height: 220px;
  background-size: auto 100%;
  box-sizing: border-box;
  background-color: black;
}
.footer-main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  padding: 60px 0;
  font-size: 0;
}
.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-logo {
  display: block;
  max-width: 100%;
  margin: 0 30px;
}
.footer-text {
  display: inline-block;
  vertical-align: middle;
  font-family: "dbtfont";
}
.footer-main p,
.footer-main p a {
  color: white;
  font-size: 18px;
  text-align: left;
}
@media screen and (max-width: 1000px) {
  .footer {
      max-width: 750px;
      margin: auto;
    }
  .footer-main {
    padding: 7% 0;
    display: inherit;
  }
  .footer-main p,
  .footer-main p a {
    color: white;
    font-size: 14px;
    text-align: center;
  }
  .footer-logo {
    display: block;
    vertical-align: middle;
    width: 30%;
    margin-right: 2%;
  }
  .footer-text {
    width: 100%;
    display: block;
    vertical-align: middle;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue